import React from 'react';
import { useAppSelector } from 'redux/store';
import RatioGauge from "./RatioGauge";


const RatioGauge_High= () => {
    const ratio = useAppSelector((state => state.user.ratio.HighMacro));

    return (
        <RatioGauge ratio={ratio} />
    )
};

export default RatioGauge_High;
